import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { articleKategorie } from '@/mocks/articles';

export default function ArticleKategorie() {
  return <ArticleTemplate data={articleKategorie} />;
}